import { render, staticRenderFns, recyclableRender, components } from "./commentItem.vue?vue&type=template&id=79b98bc6&scoped=true&"
var renderjs
import script from "./commentItem.vue?vue&type=script&lang=js&"
export * from "./commentItem.vue?vue&type=script&lang=js&"
import style0 from "./commentItem.vue?vue&type=style&index=0&id=79b98bc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b98bc6",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/merchant/merchatCenter/commentManger/commentItem.vue"
export default component.exports